import {animation, availableAnimations} from "../../global/global-animation";
import {breakpoints} from "../sal-breakpoint/sal-breakpoint";

class Lightbox {
    constructor(options = {}) {
        this.options = {
            mode: 'gallery',
            breakpointCondition: () => {
                return window.innerWidth >= breakpoints.lg;
            },
            gallery: {
                galleryClass: 'ce-gallery__lightbox',
                imageLinkClass: 'lightbox',
                galleryImageClass: 'gallery__image',
            },
            grid: {
                imageWrapperclass: 'ce-gallery__grid',
                imageLinkClass: 'lightbox'
            },
            single: {
                imageWrapperclass: 'gallery__single',
                imageLinkClass: 'lightbox'
            },
            lightboxClass: 'sal-lightbox',
            lightboxActiveImage: 'lightbox--active-image',
            noScrollClass: 'no-scroll',
            animationDuration: '250ms'
        };

        Object.assign(this.options, options);
        if (this.options.mode === 'gallery') {
            const lightboxReferences = document.querySelectorAll(`.${this.options.gallery.galleryClass}`);

            lightboxReferences.forEach(lightboxElement => {
                const imageLinks = lightboxElement.querySelectorAll(`.${this.options.gallery.imageLinkClass}`);
                imageLinks.forEach(imageLink => {
                    imageLink.addEventListener('click', e => {
                        if (this.options.breakpointCondition()) {
                            e.preventDefault();
                            const triggeredLink = e.currentTarget;
                            this.showLightbox(triggeredLink, true);
                        }
                    });
                })
            });
        }

        if (this.options.mode === 'single' || this.options.mode === 'grid') {
            const lightboxReferences = document.querySelectorAll(`.${this.options[this.options.mode].imageWrapperclass} .${this.options[this.options.mode].imageLinkClass}`);
            lightboxReferences.forEach(lightboxElement => {
                lightboxElement.addEventListener('click', e => {
                    if (this.options.breakpointCondition()) {
                        e.preventDefault();
                        const triggeredLink = e.currentTarget;
                        this.showLightbox(triggeredLink, false);
                    }
                });
            });
        }
    }

    showLightbox(link, galleryMode) {
        let previousImageLinks = [];
        let nextImageLinks = [];

        const imageLink = link.href;
        const imageCaption = link.dataset.caption;
        const imageTitle = link.dataset.title;
        const imageAlt = link.dataset.alt;

        if (galleryMode) {
            const galleryImage = link.closest(`.${this.options.gallery.galleryImageClass}`);

            let hasPrevSibling;
            let prevSibling = galleryImage.previousElementSibling;

            if (prevSibling) {
                do {
                    const prevSiblingElement = prevSibling.querySelector(`.${this.options.gallery.imageLinkClass}`);
                    if (prevSiblingElement) {
                        previousImageLinks.push({
                            link: prevSiblingElement.href,
                            caption: prevSiblingElement.dataset.caption,
                            title: prevSiblingElement.dataset.title,
                            alt: prevSiblingElement.dataset.alt
                        });
                    }

                    if (prevSibling.previousElementSibling) {
                        hasPrevSibling = true;
                        prevSibling = prevSibling.previousElementSibling;
                    } else {
                        hasPrevSibling = false;
                    }
                } while (hasPrevSibling);
            }
            hasPrevSibling = null;

            let hasNextSibling;
            let nextSibling = galleryImage.nextElementSibling;

            if (nextSibling) {
                do {
                    const nextSiblingElement = nextSibling.querySelector(`.${this.options.gallery.imageLinkClass}`);
                    if (nextSiblingElement) {
                        nextImageLinks.push({
                            link: nextSiblingElement.href,
                            caption: nextSiblingElement.dataset.caption,
                            title: nextSiblingElement.dataset.title,
                            alt: nextSiblingElement.dataset.alt
                        });
                    }

                    if (nextSibling.nextElementSibling) {
                        hasNextSibling = true;
                        nextSibling = nextSibling.nextElementSibling;
                    } else {
                        hasNextSibling = false;
                    }
                } while (hasNextSibling);
            }
            hasNextSibling = null;
        }

        const lightbox = document.createElement('div');
        lightbox.classList.add(this.options.lightboxClass);
        lightbox.classList.add('sal-lightbox--wrapper');

        const lightboxContent = document.createElement('div');
        lightboxContent.classList.add('sal-lightbox--content');

        const lightboxHeader = document.createElement('div');
        lightboxHeader.classList.add('sal-lightbox--header');

        const lightboxFooterWrapper = document.createElement('div');
        lightboxFooterWrapper.classList.add('sal-lightbox--footer-wrapper');

        const lightboxFooter = document.createElement('div');
        lightboxFooter.classList.add('sal-lightbox--footer');

        const btnControls = document.createElement('div');
        btnControls.classList.add('lightbox--controls');

        if (galleryMode) {
            previousImageLinks = previousImageLinks.reverse();
            previousImageLinks.forEach(linkObject => {
                const image = new Image();
                image.onload = e => {
                    if (e.target.width / e.target.height < (e.target.parentNode.clientWidth - 40) / (e.target.parentNode.clientHeight - 120)) {
                        e.target.classList.add('max-height');
                    } else {
                        e.target.classList.add('max-width');
                    }
                };
                image.src = linkObject.link;
                if (linkObject.title) {
                    image.title = linkObject.title;
                }
                if (linkObject.alt) {
                    image.alt = linkObject.alt;
                }

                image.setAttribute("data-caption", linkObject.caption ? linkObject.caption : '');
                lightboxContent.append(image);
            });
        }

        let currentImage = new Image();
        currentImage.classList.add(this.options.lightboxActiveImage);
        currentImage.onload = e => {
            if (e.target.width / e.target.height < (e.target.parentNode.clientWidth - 40) / (e.target.parentNode.clientHeight - 120)) {
                e.target.classList.add('max-height');
            } else {
                e.target.classList.add('max-width');
            }

        };

        currentImage.src = imageLink;

        if (imageTitle) {
            currentImage.title = imageTitle;
        }
        if (imageAlt) {
            currentImage.alt = imageAlt;
        }

        if (imageCaption) {
            currentImage.setAttribute("data-caption", imageCaption);
        } else {
            currentImage.setAttribute("data-caption", '');
        }

        lightboxContent.append(currentImage);
        const caption = document.createElement('p');
        caption.classList.add('lightbox--caption');
        caption.innerText = imageCaption ? imageCaption : '';

        if (galleryMode) {
            nextImageLinks.forEach(linkObject => {
                const image = new Image();
                image.onload = e => {
                    if (e.target.width / e.target.height < (e.target.parentNode.clientWidth - 40) / (e.target.parentNode.clientHeight - 120)) {
                        e.target.classList.add('max-height');
                    } else {
                        e.target.classList.add('max-width');
                    }
                };

                image.src = linkObject.link;
                if (linkObject.title) {
                    image.title = linkObject.title;
                }
                if (linkObject.alt) {
                    image.alt = linkObject.alt;
                }

                image.setAttribute("data-caption", linkObject.caption ? linkObject.caption : '');
                lightboxContent.append(image);
            });
        }

        if ((nextImageLinks.length || previousImageLinks.length) && galleryMode) {
            const btnNext = document.createElement('button');
            const btnPrev = document.createElement("button");

            if (nextImageLinks.length === 0) {
                btnNext.classList.add('inactive');
            }

            if (previousImageLinks.length === 0) {
                btnPrev.classList.add('inactive');
            }

            btnNext.classList.add('lightbox--next');
            btnPrev.classList.add('lightbox--prev');

            btnNext.addEventListener('click', e => {
                const lightbox = e.target.closest(`.${this.options.lightboxClass}`);
                const activeImage = lightbox.querySelector(`.${this.options.lightboxActiveImage}`);

                if (activeImage.nextElementSibling) {
                    lightbox.querySelector(`.lightbox--caption`).innerText = activeImage.nextElementSibling.dataset.caption;
                    animation.addAnimation(activeImage, availableAnimations.fades.fadeOutLeft, this.options.animationDuration, [
                        {
                            eventType: 'animationend',
                            eventCallback: e => {
                                e.target.classList.remove(this.options.lightboxActiveImage);
                                e.target.style.cssText = '';

                                activeImage.nextElementSibling.style.display = 'block';
                                animation.addAnimation(activeImage.nextElementSibling, availableAnimations.fades.fadeInRight, this.options.animationDuration, [
                                    {
                                        eventType: 'animationend',
                                        eventCallback: e => {
                                            e.target.classList.add(this.options.lightboxActiveImage);
                                            e.target.style.cssText = '';

                                            btnNext.classList.toggle('inactive', !e.target.nextElementSibling);
                                            btnPrev.classList.toggle('inactive', !e.target.previousElementSibling);
                                        }
                                    }
                                ]);
                            }
                        }
                    ]);
                }
            });

            btnPrev.addEventListener('click', e => {
                const lightbox = e.target.closest(`.${this.options.lightboxClass}`);
                const activeImage = lightbox.querySelector(`.${this.options.lightboxActiveImage}`);

                if (activeImage.previousElementSibling) {
                    lightbox.querySelector(`.lightbox--caption`).innerText = activeImage.previousElementSibling.dataset.caption;
                    animation.addAnimation(activeImage, availableAnimations.fades.fadeOutRight, this.options.animationDuration, [
                        {
                            eventType: 'animationend',
                            eventCallback: e => {
                                e.target.classList.remove(this.options.lightboxActiveImage);
                                e.target.style.cssText = '';

                                activeImage.previousElementSibling.style.display = 'block';
                                animation.addAnimation(activeImage.previousElementSibling, availableAnimations.fades.fadeInLeft, this.options.animationDuration, [
                                    {
                                        eventType: 'animationend',
                                        eventCallback: e => {
                                            e.target.classList.add(this.options.lightboxActiveImage);
                                            e.target.style.cssText = '';
                                            btnNext.classList.toggle('inactive', !e.target.nextElementSibling);
                                            btnPrev.classList.toggle('inactive', !e.target.previousElementSibling);
                                        }
                                    }
                                ])
                            }
                        }
                    ]);

                }
            });
            btnControls.append(btnPrev, btnNext);
        }

        const btnClose = document.createElement("button");
        btnClose.classList.add('lightbox--close');
        btnClose.addEventListener('click', e => {
            const lightbox = e.target.closest(`.${this.options.lightboxClass}`);
            lightbox.parentNode.removeChild(lightbox);
            document.body.classList.remove(this.options.noScrollClass);
        });

        lightboxHeader.append(btnClose);
        lightbox.append(lightboxHeader);

        lightbox.append(lightboxContent);

        lightboxFooter.append(caption, btnControls);
        lightboxFooterWrapper.append(lightboxFooter);
        lightbox.append(lightboxFooterWrapper);

        document.body.append(lightbox);
        document.body.classList.add(this.options.noScrollClass);
    }

    getOptions() {
        return this.options;
    }
}

export {Lightbox}
